import moment from 'moment';
import BaseServiceCrud from './BaseServiceCrud';
import Constants from '../utils/constants';

export default class RankingService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'ranking';
    }
    getCriteria(criteria) {
        const dateNow = moment();
        const params = {
            first_result: criteria.firstResult,
            type: criteria.type,
            transportId: criteria.transportId,
            max_results: criteria.maxResults,
            activityType: criteria.activityType,
        };
        if (criteria.dateFrom || criteria.dateTo) {
            params.date_from = criteria.dateFrom
                ? moment(criteria.dateFrom).format(Constants.DATE_GET_REQUEST_FORMAT)
                : undefined;
            params.date_to = criteria.dateTo
                ? moment(criteria.dateTo).format(Constants.DATE_GET_REQUEST_FORMAT)
                : undefined;
        } else {
            params.date = criteria.date ? moment(criteria.date).format(Constants.DATE_GET_REQUEST_FORMAT) : dateNow;
        }
        const queryString = this.objToQueryString(params);
        return queryString;
    }

    getRanking(criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/list/${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getGroupRankingCriteria(criteria) {
        return this.objToQueryString({
            first_result: criteria.firstResult,
            max_results: criteria.maxResults,
            date_from: criteria.dateFrom
                ? moment(criteria.dateFrom).format(Constants.DATE_GET_REQUEST_FORMAT)
                : undefined,
            date_to: criteria.dateTo
                ? moment(criteria.dateTo).format(Constants.DATE_GET_REQUEST_FORMAT)
                : undefined,
            activity: criteria.activity,
        });
    }

    getGroupRanking(criteria) {
        const queryString = this.getGroupRankingCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/group-list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getGroupMemberRanking(groupId, criteria) {
        const queryString = this.getGroupRankingCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/group/${groupId}/user-list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
